<!---数据统计--->
<template>
  <div>
    <div class="filter-container">
      <el-row class="filter-top" type="flex" justify="end">
        <el-col :span="isMB?11:16">
          <span class="span-top-text" style="line-height:39px;">查询条件</span>
          <div class="searchIcon" @click="showForm = !showForm">
            <i :class="showForm?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
          </div>
        </el-col>
        <el-col :span="isMB?13:8">
          <div class="btn-search">
            <el-button type="primary" icon="el-icon-search" @click="onQuery()">搜索</el-button>
            <el-button type="primary" plain @click="resetQuery">重置</el-button>
            <el-button type="success" plain @click="onExport">导出</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row v-show="showForm">
        <el-divider style="margin:0px;"></el-divider>
        <el-form label-width="85px" class="form-item" :class="{'form-item-left':isMB}">
          <el-form-item label="对账日期">
            <range-picker
              ref="picker"
              :date="[params.StartDate,params.EndDate]"
              @change="(x)=>{params.StartDate=x.Start;params.EndDate=x.End}"
            />
          </el-form-item>
          <el-form-item label="对账人员">
            <select-input
              placeholder="选择人员"
              :label="params.MemberName"
              v-model="params.MemberId"
              @click="openMember"
            />
            <!-- <el-input v-model="params.MemberName" placeholder="请输入对账人员" /> -->
          </el-form-item>
        </el-form>
      </el-row>
    </div>
    <div class="table-box">
      <div class="tb-itme">
        <div class="row-tb-head">账号充值明细</div>
        <el-table :data="recharge" border v-loading="loading1" max-height="500px" show-summary>
          <el-table-column prop="RechargeTime" label="到账时间" min-width="140" />
          <el-table-column prop="RechargeAmount" label="到账金额" />
        </el-table>
      </div>
      <div class="tb-itme">
        <div class="row-tb-head">微信交易明细</div>
        <el-table :data="wxtrade" border v-loading="loading3" max-height="500px" show-summary>
          <el-table-column prop="TradeTime" label="交易时间" min-width="140" />
          <el-table-column prop="OrderAmount" label="交易金额" />
        </el-table>
      </div>
      <div class="tb-itme">
        <div class="row-tb-head">后台充值明细</div>
        <el-table :data="give" v-loading="loading5" border max-height="500px" show-summary>
          <el-table-column prop="GiveTime" label="后台充值时间" min-width="140" />
          <el-table-column prop="GiveAmount" label="后台充值余额" min-width="140" />
        </el-table>
      </div>
      <div class="tb-itme">
        <div class="row-tb-head">账号消费明细</div>
        <el-table :data="consume" v-loading="loading2" border max-height="500px" show-summary>
          <el-table-column prop="ConsumeTime" label="消费时间" min-width="140" />
          <el-table-column prop="ConsumeAmount" label="消费金额" />
        </el-table>
      </div>
      <div class="tb-itme">
        <div class="row-tb-head">机器交易明细</div>
        <el-table :data="upconsume" v-loading="loading4" border max-height="500px" show-summary>
          <el-table-column prop="RecTime" label="交易时间" min-width="140" />
          <el-table-column prop="Amount" label="交易金额" />
        </el-table>
      </div>
      <div class="tb-itme">
        <div class="row-tb-head">退款明细</div>
        <el-table :data="refund" v-loading="loading6" border max-height="500px" show-summary>
          <el-table-column prop="RefundTime" label="退款时间" min-width="140" />
          <el-table-column prop="RefundAmount" label="退款金额" />
        </el-table>
      </div>
    </div>
    <member-dialog ref="memberDialog" @select="setMember" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import memberDialog from "./memberDialog";

export default {
  mixins: [listMixin],
  components: { list, memberDialog },
  data() {
    return {
      api: require("@/api/cp/bill").default,
      recharge_api: require("@/api/cp/recharge").default,
      consume_api: require("@/api/cp/consume").default,
      wxtrade_api: require("@/api/cp/wxtrade").default,
      upconsume_api: require("@/api/cp/upconsume").default,
      give_api: require("@/api/cp/give").default,
      refund_api: require("@/api/cp/refund").default,
      isMB: this.$store.state.isMB,
      showForm: !this.$store.state.isMB,
      recharge: [],
      loading1: false,
      consume: [],
      loading2: false,
      wxtrade: [],
      loading3: false,
      upconsume: [],
      loading4: false,
      give: [],
      loading5: false,
      refund: [],
      loading6: false,
      params: {
        MemberName: "",
        MemberId: null,
        MemberType: null,
        // MemberNo: "",
        StartDate: this.$commonJs.getToday(),
        EndDate: this.$commonJs.getToday(),
      },
    };
  },
  methods: {
    openMember() {
      this.$refs.memberDialog.open().then((that) => {
        that.init();
      });
    },
    setMember(data) {
      console.log("member", JSON.parse(JSON.stringify(data)));
      this.params.MemberId = data.MemberId;
      this.params.MemberName = data.MemberName;
      this.params.MemberType = data.MemberType;
    },
    getData() {
      var recharge = {
        RechargeStartDate: this.params.StartDate,
        RechargeEndDate: this.params.EndDate,
        MemberId: this.params.MemberId,
        MemberType: this.params.MemberType,
      };
      recharge = this.$commonJs.obj.removeNullKey(recharge);
      this.loading1 = true;
      this.recharge_api.list(recharge).then((res) => {
        this.loading1 = false;
        this.recharge = res.Data;
      });

      var consume = {
        ConsumeStartDate: this.params.StartDate,
        ConsumeEndDate: this.params.EndDate,
        MemberId: this.params.MemberId,
        MemberType: this.params.MemberType,
      };
      consume = this.$commonJs.obj.removeNullKey(consume);
      this.loading2 = true;
      this.consume_api.list(consume).then((res) => {
        this.loading2 = false;
        this.consume = res.Data;
      });

      var wxtrade = {
        TradeStartDate: this.params.StartDate,
        TradeEndDate: this.params.EndDate,
        MemberId: this.params.MemberId,
        MemberType: this.params.MemberType,
      };
      wxtrade = this.$commonJs.obj.removeNullKey(wxtrade);
      this.loading3 = true;
      this.wxtrade_api.list(wxtrade).then((res) => {
        this.loading3 = false;
        this.wxtrade = res.Data;
      });

      var upconsume = {
        RecStartDate: this.params.StartDate,
        RecEndDate: this.params.EndDate,
        MemberId: this.params.MemberId,
        MemberType: this.params.MemberType,
      };
      upconsume = this.$commonJs.obj.removeNullKey(upconsume);
      this.loading4 = true;
      this.upconsume_api.list(upconsume).then((res) => {
        this.loading4 = false;
        this.upconsume = res.Data;
      });

      var give = {
        GiveStartDate: this.params.StartDate,
        GiveEndDate: this.params.EndDate,
        MemberId: this.params.MemberId,
        MemberType: this.params.MemberType,
      };
      give = this.$commonJs.obj.removeNullKey(give);
      this.loading5 = true;
      this.give_api.list(give).then((res) => {
        this.loading5 = false;
        this.give = res.Data;
      });

      var refund = {
        RefundStartDate: this.params.StartDate,
        RefundEndDate: this.params.EndDate,
        MemberId: this.params.MemberId,
        MemberType: this.params.MemberType,
        Status: 3,
      };
      refund = this.$commonJs.obj.removeNullKey(refund);
      this.loading6 = true;
      this.refund_api.list(refund).then((res) => {
        this.loading6 = false;
        this.refund = res.Data;
      });
      // this.deviceLoading = true;
      // this.recharge_api.list({}).then((res) => {});
    },
    onQuery() {
      // this.params.PageIndex = 1;
      // this.params.PageSize = 10;
      if (this.params.MemberId) {
        this.getData();
      } else {
        this.$message.warning("请先选择人员");
      }
    },
    resetQuery() {
      this.params.MemberName = "";
      this.params.MemberId = null;
      this.params.MemberType = null;
      this.params.StartDate = this.$commonJs.getToday();
      this.params.EndDate = this.$commonJs.getToday();
      this.$refs.picker.clear();
      // this.getData();
    },
    onExport() {
      if (this.params.MemberId) {
        var loading = this.$loading({
          lock: true,
          text: "正在导出...",
          spinner: "el-icon-loading",
          customClass: "my_loading",
          background: "rgba(0, 0, 0, 0.3)",
        });
        var params = this.$commonJs.obj.removeNullKey(this.params);
        this.api.exportDetail(params).then(() => {
          loading.close();
        });
      } else {
        this.$message.warning("请先选择人员");
      }
    },
  },
};
</script>
<style lang="scss">
.table-box {
  display: flex;
  justify-content: space-between;
  overflow: auto;
  padding-bottom: 10px;

  .tb-itme + .tb-itme {
    margin-left: 5px;
  }
}
</style>